import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import {
  headingFonts,
  primaryButtonStyles,
  secondaryButtonStyles,
  textFieldStyles,
} from "../../../../Styles/Styles";

export default function RejectReasonModal({ open, onClose, onConfirm }) {
  const [rejectReason, setRejectReason] = useState("");

  const handleConfirm = () => {
    if (!rejectReason.trim()) {
      alert("Please provide a rejection reason.");
      return;
    }
    onConfirm(rejectReason);
    setRejectReason(""); // Reset input after confirm
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ ...headingFonts }}>Rejection Reason</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Reason"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
          multiline
          rows={3}
          sx={{ ...textFieldStyles, mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ ...secondaryButtonStyles }}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} sx={{ ...primaryButtonStyles }}>
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
}
